import { Avatar, Image } from 'antd';
import LogoUltracarWhite from '@/assets/images/logo-ultracar-white.png';
import { UserAvatarProps } from './types';
import './styles.less';

const genderType = {
  Feminino: 'feminine',
  Masculino: 'masculine',
};

const UserAvatar: React.FC<UserAvatarProps> = ({
  gender,
  picture,
  size = 30,
}) => {
  return (
    <Avatar
      className={`user-avatar ${
        gender ? `user-avatar-${genderType[gender]}` : ''
      }`}
      size={size}
      src={
        <Image
          preview={false}
          src={picture ?? LogoUltracarWhite}
          style={{ width: size - 4, height: size - 4, objectFit: 'cover' }}
        />
      }
    />
  );
};

export default UserAvatar;
